import { render, staticRenderFns } from "./TargetPriceForecast.vue?vue&type=template&id=da46a030&scoped=true"
import script from "./TargetPriceForecast.vue?vue&type=script&lang=js"
export * from "./TargetPriceForecast.vue?vue&type=script&lang=js"
import style0 from "./TargetPriceForecast.vue?vue&type=style&index=0&id=da46a030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da46a030",
  null
  
)

export default component.exports